import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'usuario-logado');

const divisaoActions = {
  divisao: { method: 'GET', url: `${basePath}/divisao` },
  hierarquiaDivisao: { method: 'GET', url: `${basePath}/divisao/hierarquia{?exceto*}` },
  regional: { method: 'GET', url: `${basePath}/regional` },
  cliente: { method: 'GET', url: `${basePath}/divisao/cliente` },
  clienteHierarquia: { method: 'GET', url: `${basePath}/divisao/hierarquia/clientes{?exceto*&idsDivisao*}` },

};

export default resource => resource(`${basePath}`, {}, divisaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/usuario-logado.js